import { useState } from 'react'
import clsx from 'clsx'

const AVATAR_COLORS = [
  'bg-red-600', 'bg-orange-600', 'bg-amber-600', 'bg-yellow-600',
  'bg-lime-600', 'bg-green-600', 'bg-emerald-600', 'bg-teal-600',
  'bg-cyan-600', 'bg-blue-600', 'bg-indigo-600', 'bg-purple-600',
]

function hashString(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0
  }
  return Math.abs(hash)
}

interface TeamAvatarProps {
  name: string
  logoUrl?: string | null
  colorSeed?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeMap = { sm: 'w-7 h-7 text-[10px]', md: 'w-9 h-9 text-xs', lg: 'w-12 h-12 text-sm' }

export function TeamAvatar({ name, logoUrl, colorSeed, size = 'md', className }: TeamAvatarProps) {
  const [imgError, setImgError] = useState(false)

  if (logoUrl && !imgError) {
    return (
      <img
        src={logoUrl}
        alt={name}
        onError={() => setImgError(true)}
        className={clsx('rounded-full object-contain shrink-0 bg-white', sizeMap[size], className)}
      />
    )
  }

  const color = AVATAR_COLORS[hashString(colorSeed || name) % AVATAR_COLORS.length]
  const initials = name.split(' ').map(w => w[0]).join('').slice(0, 3).toUpperCase()

  return (
    <div className={clsx(
      'rounded-full flex items-center justify-center font-bold text-white select-none shrink-0',
      color, sizeMap[size], className,
    )}>
      {initials}
    </div>
  )
}
